import React from "react"
import { Card, Container, Image, Name, Description } from "./styles"

const PersonCard = ({
  id,
  name,
  link,
  description,
  imageUrl,
  middleElement,
  mobileHorizontal,
imageProps,
  dataId,
  hideIdentity,
  ...props
}) => {
  const renderContent = () => (
    <>
      <figure>
        <Image
          {...imageProps}
          baseUrl={imageUrl}
          alt={name}
          images={[
            {
              transforms: "c_fill,g_auto,w_542,h_542,q_auto,f_auto,fl_lossy",
              screenSize: 1024,
            },
            {
              transforms: "c_fill,g_auto,w_224,h_224,q_auto,f_auto,fl_lossy",
              screenSize: 768,
            },
            {
              transforms: `c_fill,g_auto,w_${mobileHorizontal ? "140" : "230"},h_${
                mobileHorizontal ? "140" : "230"
              },q_auto,f_auto,fl_lossy`,
            },
          ]}
          lazy
        />
      </figure>
      {!hideIdentity && <Name>{name}</Name>}
    </>
  )

  return (
    <Card data-exp-id={dataId} {...props}>
      <Container>
        {link ? <a href={link}>{renderContent()}</a> : renderContent()}
        {middleElement}
        {!hideIdentity && <Description>{description}</Description>}
      </Container>
    </Card>
  )
}

export default PersonCard
